import axiosInstance from './axiosInstance';
import type { SellerGamificationDashboard } from '../../types/sellerGamification.types';

export const sellerGamificationService = {
  async getDashboard(): Promise<SellerGamificationDashboard> {
    const response = await axiosInstance.get<SellerGamificationDashboard>(
      '/seller/gamification/dashboard',
    );
    return response.data;
  },

  async dismissCelebration(unlockId: string): Promise<void> {
    await axiosInstance.post(`/seller/gamification/celebrations/${unlockId}/dismiss`);
  },

  async dismissAllCelebrations(): Promise<void> {
    await axiosInstance.post('/seller/gamification/celebrations/dismiss-all');
  },

  async sync(): Promise<SellerGamificationDashboard> {
    const response = await axiosInstance.post<SellerGamificationDashboard>(
      '/seller/gamification/sync',
    );
    return response.data;
  },

  /** Dev-only — mirrors backend growth/debug endpoint. */
  async getGrowthDebug(): Promise<{
    growthOsSource?: string;
    growthOsPresent?: boolean;
    recentEventsCount?: number;
    recentEventTypes?: string[];
    weeklyListingActivity?: number;
    weeklyEventCounts?: Record<string, number>;
    missionProgress?: Array<{
      missionId: string;
      progress: number;
      target: number;
      status: string;
      idempotencyKey: string;
    }>;
    lastUpdatedAt?: string;
  }> {
    const response = await axiosInstance.get('/seller/gamification/growth/debug');
    return response.data;
  },
};
